import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const AnnouncementsSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Announcements Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Subject",
                                key: "subject",
                                format: "link",
                            },
                            {
                                label: "Message",
                                key: "message",
                            },
                        ]}
                        columnB={[
                            {
                                label: "Host",
                                key: "host",
                                format: "modelLink"
                            },
                        ]}
                        columnC={[
                            {
                                label: "Expires On",
                                key: "expireOn",
                                format: "date"
                            },
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default AnnouncementsSingleView;
